import { FETCH_MISSING_ONEITSM_SERVICE_CUSTOMER } from "../actionTypes"
import { fetchAllMissingOneItsmCustomers } from "../../../api/userManagement/getAllCustomerList.service"

const request = ()=>({type: FETCH_MISSING_ONEITSM_SERVICE_CUSTOMER.REQUEST})
const failure = (error)=>({type: FETCH_MISSING_ONEITSM_SERVICE_CUSTOMER.FAILURE, error})
const success = (obj)=>({type: FETCH_MISSING_ONEITSM_SERVICE_CUSTOMER.SUCCESS, obj})

export const getAllMissingOneItsmCustomers = ()=>{
    return (dispatch, getState)=>{        
        dispatch(request()) 
        return fetchAllMissingOneItsmCustomers()  
        .then(response => {   
            let obj={
                data: response?.data,
                totalcount:response?.totalIVCCustomers
            }    
            dispatch(success(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(failure(error?.message))
            return Promise.resolve(false)
        })
    }
}